<template>
  <v-layout
    column
    wrap
  >
    <v-layout
      justify-end
      class="mb-3"
    >
      <v-btn
        dark
        color="blue"
        @click.stop="_openCreateSecurityDialog()"
      >
        <v-icon dark>
          add
        </v-icon>Create
      </v-btn>
    </v-layout>

    <v-data-table
      :headers="headers"
      :items="securities"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
      class="elevation-1"
      @update:pagination="updatePagination"
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <tr>
          <td
            v-for="(header, index) in headers"
            :key="index"
            class="text-xs"
          >
            <div v-if="header.action">
              <v-btn
                flat
                icon
                color="blue"
                @click="_editSecurity(props.item)"
              >
                <v-icon>edit</v-icon>
              </v-btn>

              <v-btn
                flat
                icon
                color="red"
                @click="_deleteSecurity(props.item.id)"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </div>
            <div v-else>
              {{ props.item[header.value] }}
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>

    <update-security
      :dialog="isOpenUpdateDialog"
      :data="securityData"
      :submit-btn-label="updateLabel"
      :cancel-btn-label="&quot;Cancel&quot;"
      :head-text="updateLabel"
      :update-error="updateError"
      :processing="isProcessSecurityAction"
      :submit-action="_submitUpdateSecurity"
      :cancel-action="_cancelUpdateSecurity"
    />

    <confirm-dialog
      :dialog="isOpenConfirmDialog"
      :confirm-btn-label="'Yes'"
      :cancel-btn-label="'No'"
      :head-text="'Confirm'"
      :description="'Are you sure to delete this security?'"
      :processing="isProcessSecurityAction"
      :confirm-action="_confirmDeleteSecurity"
      :cancel-action="_cancelDeleteSecurity"
    />
  </v-layout>
</template>

<script>
import { mapActions } from 'vuex';
import ConfirmDialog from '../shared/ConfirmDialog';
import UpdateSecurity from './UpdateSecurity';
import { setQuery } from '@/helpers';

export default {
  name: 'SecurityList',
  components: {
    ConfirmDialog,
    UpdateSecurity,
  },
  props: {
    securities: {
      type: Array,
      default: () => ([]),
    },
    getSecurities: {
      type: Function,
      default: () => ({}),
    },
  },
  data() {
    return {
      isOpenUpdateDialog: false,
      isOpenConfirmDialog: false,
      isProcessSecurityAction: false,
      selectedSecurityId: -1,
      securityData: {},
      updateLabel: 'Create',
      updateError: '',
      pagination: {
        page: 1,
        rowsPerPage: 10,
        totalItems: this.securities.length,
      },
      rowsPerPageItems: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 },
        { text: 'All', value: -1 },
      ],
      headers: [
        {
          text: 'WKN',
          value: 'wkn',
        },
        {
          text: 'Title',
          value: 'title',
        },
        {
          text: 'Isin',
          value: 'isin',
        },
        {
          text: 'Financing Entity ID',
          value: 'financing_entity_id',
        },
        {
          text: 'Max Amount',
          value: 'max_amount',
        },
        {
          text: 'Action',
          action: true,
        },
      ],
    };
  },
  watch: {
    pagination: {
      handler() {
        this.isLoadTableData = true;
      },
    },
  },
  async mounted() {
    await this.$nextTick();
    this.changePage();
  },
  methods: {
    ...mapActions([
      'createSecurity',
      'updateSecurityByWKN',
      'deleteSecurityById',
    ]),
    _editSecurity(security) {
      this.updateLabel = 'Update';
      this.updateError = '';
      this.securityData = security;
      this.isOpenUpdateDialog = true;
    },
    _deleteSecurity(id) {
      this.selectedSecurityId = id;
      this.isOpenConfirmDialog = true;
    },
    async _confirmDeleteSecurity() {
      this.isProcessSecurityAction = true;

      try {
        await this.deleteSecurityById({
          id: this.selectedSecurityId,
        });
        this.isOpenConfirmDialog = false;
        this.isProcessSecurityAction = false;
        this.getSecurities();
      } catch (e) {
        console.error(e);
        this.isOpenConfirmDialog = true;
        this.isProcessSecurityAction = false;
      }
    },
    _cancelDeleteSecurity() {
      this.isOpenConfirmDialog = false;
    },
    _openCreateSecurityDialog() {
      this.updateLabel = 'Create';
      this.updateError = '';
      this.securityData = {
        wkn: null,
        isin: null,
        financing_entity_id: null,
        max_amount: 1,
      };
      this.isOpenUpdateDialog = true;
    },
    async _submitUpdateSecurity(data) {
      this.isProcessSecurityAction = true;

      try {
        if (this.updateLabel === 'Create') {
          await this.createSecurity(data);
          this.isOpenUpdateDialog = false;
          this.isProcessSecurityAction = false;
        } else if (data.wkn) {
          await this.updateSecurityByWKN({
            wkn: data.wkn,
            isin: data.isin,
            max_amount: data.max_amount,
            financing_entity_id: data.financing_entity_id,
          });
          this.isOpenUpdateDialog = false;
          this.isProcessSecurityAction = false;
        } else {
          this.isOpenUpdateDialog = true;
          this.isProcessSecurityAction = false;
          throw new Error('Invalid WKN');
        }

        this.getSecurities();
      } catch (e) {
        console.error(e);
        this.updateError = 'Invalid WKN';
        this.isOpenUpdateDialog = true;
        this.isProcessSecurityAction = false;
      }
    },
    _cancelUpdateSecurity() {
      this.isOpenUpdateDialog = false;
    },
    updatePagination(pagination) {
      if (this.isLoadTableData) {
        setQuery({ page: pagination.page }, this.$route, this.$router);
      }
    },
    changePage() {
      const { page } = this.$route.query;
      this.pagination.page = page ? Number(page) : 1;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/securities/SecurityList.vue